export const moduleAccessEnum = [
    { value: 'estimate', label: 'Ведение смет' },
    { value: 'supply-management', label: 'Управление снабжением' },
    { value: 'inventory-control', label: 'Складской учет' },
    { value: 'planning', label: 'Календарно-сетевое планирование' },
    { value: 'technic', label: 'Работа с техникой' },
    { value: 'ocr', label: 'Распознавание документов' },
    { value: 'construction-control', label: 'Строй-контроль' },
  ]